import React from "react";

import { useLocation } from "react-router-dom";

import { isAdvertisingLocation, getChannelName } from "@at/formatter-utils";
import { Channel, withPageState } from "@at/sauron-platform-core";

import { parse } from "query-string";

import { withLeadPageData } from "../../../connected-components/hoc/lead-page.hoc";
import { withQueryClient } from "../../../connected-components/hoc/query-client.hoc";
import { ContactDealer } from "../loadables";

const ContactDealerWithoutLayoutPage = () => {
  const { search } = useLocation();

  const queryParam = parse(search || "")["advertising-location"];

  const channel = isAdvertisingLocation(queryParam)
    ? getChannelName(queryParam)
    : Channel.cars;
  const PageWithData = withQueryClient(withLeadPageData(ContactDealer));
  const WrappedPage = withPageState(PageWithData, { channel: channel });
  return <WrappedPage />;
};

export default ContactDealerWithoutLayoutPage;
